/*eslint-disable*/
export default [
    {
        path: '/403',
        name: '403',
        meta: {
            title: '403',
        },
        component: () => import(/* webpackPrefetch: true */'../../components/errors/403.vue')
    },
    {
        path: '/archived-user',
        name: 'archived-user',
        meta: {
            title: 'errors.archived_user',
        },
        component: () => import(/* webpackPrefetch: true */'../../components/errors/ArchivedUser.vue'),
    },
    {
        path: '/without-active-grades',
        name: 'without-active-grades',
        meta: {
            title: 'errors.without_active_grades',
        },
        component: () => import(/* webpackPrefetch: true */'../../components/errors/WithoutActiveGrades.vue'),
    },
    {
        path: '/without-active-schools',
        name: 'without-active-schools',
        meta: {
            title: 'errors.without_active_schools',
        },
        component: () => import(/* webpackPrefetch: true */'../../components/errors/WithoutActiveSchools.vue'),
    },
    {
        path: '/update-in-progress',
        name: 'update-in-progress',
        meta: {
            title: 'update-in-progress',
        },
        component: () => import(/* webpackPrefetch: true */'../../components/errors/UpdateInProgress.vue'),
    },
    {
        path: '/*',
        name: 'notFound',
        meta: {
            title: 'router.router_notFound',
            prev: {
                name: 'dashboard'
            },
        },
        component: () => import(/* webpackPrefetch: true */'../../components/errors/404.vue'),
    },
    {
        path: 'school/register',
        name: 'school:register',
        component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "school" */'../../components/school/RegisterSchool.vue'),
        props: true,
        meta: {
            title: 'router.router_addSchool',
            prev: {
                name: 'without-active-schools'
            }
        }
    },
]
